import { FC } from "react";
import React from "react";
import { FormRenderProps } from "react-final-form";
import { Field } from "react-final-form";
import Typography from "@material-ui/core/Typography";
import Loading from "../../../../components/Loading";
import { Grid } from "@material-ui/core";
import BootstrapInput from "../../../../components/BootstrapInput";
import PasswordInput from "../../../../components/PasswordInput";
import Button from "../../../../components/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from "@material-ui/core/styles";
import FormLink from "../../../../components/FormLink";
import { Routes } from "../../../../constants/routes";
import queryString from "querystring";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => ({
  error: {
    color: theme.palette.success.main,
    marginBottom: 10,
  },
  fieldsContainer: {
    marginBottom: 20,
  },
}));

const LoginForm: FC<FormRenderProps> = ({
  initialValues,
  handleSubmit,
  submitError,
  submitErrors,
  submitting,
  values,
  ...props
}) => {
  const classes = useStyles();
  const location = useLocation<any>();

  let queryParams = queryString.parse(location.search.split("?").join(""));
  let message: any = queryParams.message || location.state?.message;

  return (
    <form onSubmit={handleSubmit}>
      {(submitError || message) && (
        <Typography className={classes.error} component={"div"}>
          <Typography
            variant={"subtitle1"}
            color={submitError ? "error" : message?.color || "error"}
          >
            {submitError || message?.text || message}
          </Typography>
        </Typography>
      )}
      {submitting && <Loading />}
      <Grid container spacing={3} className={classes.fieldsContainer}>
        <Grid item xs={12}>
          <Field
            fullWidth
            type="text"
            name="email"
            label="Email"
            placeholder="Email"
            component={BootstrapInput}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            fullWidth
            name="password"
            label="Password"
            placeholder="*********"
            component={PasswordInput}
          />
        </Grid>
        <Grid item xs={12}>
          <FormLink
            to={{
              pathname: `/${Routes.FORGOT_PASSWORD}`,
              state: {
                email: values.email,
              },
            }}
          >
            Forgot Password?
          </FormLink>
        </Grid>
        <Grid item xs={12}>
          <Button
            type="submit"
            color="secondary"
            variant="contained"
            fullWidth
            disabled={submitting}
          >
            Sign in
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default LoginForm;
